//types
import {
	IOrganizationAuctionResponse,
	IOrganizationAuctionUpdateRequest,
	IOrganizationCreateAuctionRequest,
} from '@/utils/types';
//form configuration
import {AuctionFormValues} from './formConfiguration';
//enums
import {AUCTION_ACTIVITY, AUCTION_STATUS} from '@/utils/enums';

// TODO: handle the images add donors field when BE is ready
export const getCreateAuctionValues = (
	values: AuctionFormValues,
	eventId: number
): IOrganizationCreateAuctionRequest => {
	const {donors} = values;
	return {
		...values,
		eventId,
		images: [],
		donors: donors.map((donor) => ({
			logo: '',
			name: donor.name,
		})) as any,
	};
};

export const getEditableAuctionInitialValues = (values: IOrganizationAuctionResponse): AuctionFormValues => {
	const {
		name,
		value,
		minBid,
		bidIncrement,
		buyNowPrice,
		categoryId,
		description,
		donors,
		isLiveAuction,
		status,
		itemImages,
	} = values;

	return {
		images: itemImages.map(({image}) => image),
		name,
		value,
		minBid,
		bidIncrement,
		buyNowPrice,
		categoryId,
		description,
		donors: donors.map((donor) => ({id: donor.id, name: donor.name, logoUrl: donor.logoUrl})),
		isLiveAuction,
		status,
	};
};

// TODO: handle the itemImages, donors when BE is ready
export const setUpdatedAuctionValues = (values: AuctionFormValues): IOrganizationAuctionUpdateRequest => {
	const {name, value, minBid, bidIncrement, buyNowPrice, categoryId, description, donors, isLiveAuction, status} =
		values;

	const updatedDonors = donors.map((donor) => ({
		id: donor.id,
		name: donor.name,
		logo: '',
	}));

	return {
		images: [],
		name,
		value,
		minBid,
		bidIncrement,
		buyNowPrice,
		categoryId,
		description,
		donors: updatedDonors as any,
		isLiveAuction,
		status: status === AUCTION_STATUS.ACTIVE ? AUCTION_ACTIVITY.ACTIVE : AUCTION_ACTIVITY.CLOSED,
	};
};
